import { useState } from "react";
import { BRAND, SITE } from "@/config/site";
import { cn } from "@/lib/cn";

/**
 * The Miracle Assembly logo. Tries public/brand/logo.png first, then the logo on the current
 * website; if neither loads, shows the wordmark in type so the header never breaks.
 */
export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  const sources = BRAND.logo;
  const [index, setIndex] = useState(0);
  const src = sources[index];
  return (
    <span className={cn("logo", compact && "logo--compact", className)}>
      {src ? (
        <span className="logo__mark"><img src={src} alt="" className="logo__img" width={40} height={40} onError={() => setIndex((i) => i + 1)} decoding="async" /></span>
      ) : null}
      {src && BRAND.logoIncludesName ? null : (
        <svg className="logo__word" viewBox="0 0 120 45" aria-hidden="true" focusable="false">
          <text className="logo__name" x="1" y="18" textLength="118" lengthAdjust="spacing">Miracle</text>
          <text className="logo__name logo__name--b" x="1" y="40" textLength="118" lengthAdjust="spacing">Assembly</text>
        </svg>
      )}
      <span className="sr-only">{SITE.name}</span>
    </span>
  );
}
